function getCurrentYearCopyright() {
  const copyrightElement = document.getElementById("copyright");

  const currentYear = new Date().getFullYear();

  if (copyrightElement) {
    copyrightElement.textContent = `${currentYear} © Подборки полезных программ для ПК`;
  }
}

export default getCurrentYearCopyright;
